import styled from "styled-components";

export const StyledSeparator = styled.div`
  background-color: ${({ color }) => color || "white"};
  width: 60px;
  padding: 3.5px;
  margin: ${({ margin }) => margin || "20px auto"};
  border-radius: 15px;
`;
